import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import FileInput from 'assets/components/inputs/file/FileInput';
import ThemeFileInputDropzone from 'assets/components/inputs/file/themes/Theme.FileInput.Dropzone';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import MimeType from 'assets/utils/file/mimeType/MimeType';
import { HttpStatus } from 'config/Api.Config';
import { compact, first } from 'lodash';
import lenderImportExcelApi from 'models/sales/lender/importExcel/Api.Lender.ImportExcel';
import React from 'react';
import { useLenderProvider } from '../Lender.Hooks';

type ImportExcelFile = Api.Core.Lender.ImportExcel.IRequest & {
  file: Hooks.Input.File.Info;
};

const LenderImportExcel: React.FC = () => {
  const { lang } = getLocales();
  const { pageRouter, listApi } = useLenderProvider();

  return (
    <ModalForm<ImportExcelFile>
      subcomponents={ThemeModalFormDefault}
      title={lang.lenderImportExcel}
      onCancel={pageRouter.updateParams}
      onSubmit={async ({ file }) => {
        const res = await lenderImportExcelApi({ file: file.original });

        if (res.status !== HttpStatus.ok) addLog({ error: res?.message ?? lang.importError });
        else addLog({ success: lang.importSuccess });

        listApi.execute((body) => body);
        pageRouter.updateParams();
      }}
      render={({ form }) => (
        <FormWrapper>
          <FileInput
            name="file"
            allowedMimeTypes={[MimeType.appMS_EXCEL, MimeType.appOPEN_XML_SHEET]}
            label={lang.lenderImportExcel}
            fileLimit={1}
            value={compact([form.data?.file])}
            onChange={({ file }) => {
              form.update({ file: first(file) });
            }}
            class={ThemeFileInputDropzone}
          />
        </FormWrapper>
      )}
    />
  );
};

export default LenderImportExcel;
